import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/styles/index.css";

ReactDOM.render(<App show={true} />, document.getElementById("root"));
